/** Entry: read the sign-in configuration, sign in, mount. Errors land on the page, not in the console alone. */
import { render } from "preact";
import { App } from "./app.js";
import { loadConfig } from "./api.js";
import { signIn } from "./auth.js";

const root = document.getElementById("app")!;

function state(text: string, sub?: string, error = false): void {
  render(<div class="frame"><div class={`state${error ? " error" : ""}`}>{text}{sub ? <div class="sub">{sub}</div> : null}</div></div>, root);
}

async function main(): Promise<void> {
  state("Signing you in…");
  const config = await loadConfig();
  const session = await signIn(config);
  if (session === "redirecting") return; // MSAL is taking the page to the sign-in
  render(<App session={session} />, root);
}

main().catch((e: unknown) => {
  const msg = e instanceof Error ? e.message : String(e);
  state("Trellis could not sign you in.", msg, true);
});
